import { useEffect } from 'react';
import './style.css';
import { HeaderCardapio } from '../../../Components/HeaderCardapio';
import { Link, useParams, useLocation, useNavigate } from 'react-router-dom';
import { useGlobal } from '../../../GlobalContext';
import { isCardapioOnly, getCardapioReturnUrl } from '../../../Utills/cardapioNavigation';

const Sucesso = () => {
  const { data } = useGlobal();
  const location = useLocation();
  const { cliente_id } = useParams();
  const queryParams = new URLSearchParams(location.search);
  const apartamento = queryParams.get('x');
  const cliente_url = queryParams.get('id_cliente');
  const session_control = queryParams.get('session_control');
  const navigate = useNavigate(); // Hook para navegação programática
  const userLanguage = navigator.language || navigator.userLanguage; // Obtém o idioma do navegador
  const returnUrl = isCardapioOnly(location.search)
    ? getCardapioReturnUrl(cliente_id, location.search)
    : `/${cliente_id}/${location.search}`;

  // 🔹 Redireciona automaticamente após 3 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(
        returnUrl,
      );
    }, 5000);

    // Limpa o timer caso o componente seja desmontado antes
    return () => clearTimeout(timer);
  }, [navigate, returnUrl]);
  const cor2 = localStorage.getItem('cliente_cor1');
  const cor_letra = localStorage.getItem('cliente_cor_letra');
  return (
    <div>
      <HeaderCardapio />

      <div class="MainGrid">
        <div className="container__success ">
          <div
            style={{
              textAlign: 'center',
              padding: '10px',
            }}
          >
            <svg
              class="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle
                class="checkmark__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                class="checkmark__check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>

            <p>O seu pedido foi realizado com sucesso!</p>
          </div>
        </div>
        <div className="div-btn-carrinho">
          <Link
            to={returnUrl}
            className="btn-sucess"
            style={{
              background:
                cor2 === 'outra'
                  ? cor2
                  : {
                      'azul-escuro': '#3d489b',
                      azul: '#4892DF',
                      verde: '#3BBF9F',
                      cinza: '#A6B1B4',
                      'cinza-solido': '#f2f2f2',
                      vermelho: '#FF5E5E',
                      laranja: '#FF9A38',
                      amarelo: '#FFFF00',
                      roxo: '#800080',
                      dourado: '#b99c56',
                      'azul-marinho': '#1C7FBC',
                      'azul-solido': '#315694',
                      marrom: '#673C0D',
                      branco: '#FFFFFF',
                    }[cor2] || cor2,
              color: cor_letra,
            }}
          >
            Voltar
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Sucesso;
